var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditService(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.25081L2.17076 27.8616C2.16511 28.5515 2.43867 29.2174 2.93537 29.7227C3.16787 29.9641 3.45076 30.1573 3.76617 30.2901C4.08157 30.4229 4.42266 30.4924 4.76789 30.4942H21.625C21.9702 30.4924 22.3113 30.4229 22.6267 30.2901C22.9421 30.1573 23.225 29.9641 23.4575 29.7227C23.9542 29.2174 24.2278 28.5515 24.2221 27.8616V3.63264C24.2278 2.94267 23.9542 2.27678 23.4575 1.77147C23.225 1.53006 22.9421 1.33687 22.6267 1.20409C22.3113 1.07131 21.9702 1.00181 21.625 1H8.37176L4.66594 4.05212L2 6.25081ZM2 6.25081L8.37176 1.32305L8.3845 1.33028L8.58075 6.39305L2 6.25081Z",
    stroke: "#A3A3A3",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45312 11.1458L21.2057 11.105",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45312 15.531H21.2296",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45312 19.9163H21.2296",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45312 24.3015H21.2296",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23 7.5L23.2391 17.5873L17.9312 23.8062C17.5451 24.2585 17.0333 24.5859 16.4608 24.7467L14.6895 25.2444C13.3701 25.6151 12.0772 24.5789 12.1515 23.2105L12.2453 21.4835C12.28 20.8446 12.518 20.2335 12.9247 19.7396L23 7.5Z",
    fill: "#4E4E4E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5321 6.36061C26.301 5.44595 27.6658 5.32777 28.5804 6.09665C29.4951 6.86552 29.6133 8.2303 28.8444 9.14496L24.9549 13.7719L21.6426 10.9875L25.5321 6.36061Z",
    fill: "#4E4E4E",
    stroke: "#A3A3A3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9168 22.7448C16.7511 22.9418 16.5447 23.1007 16.3118 23.2104C14.9344 23.8593 13.4298 22.5946 13.8323 21.1261C13.9004 20.8778 14.0214 20.6472 14.1871 20.4501L15.3665 19.0471L18.0962 21.3417L16.9168 22.7448Z",
    fill: "#4E4E4E",
    stroke: "#A3A3A3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.2895,
    y: 11.997,
    width: 3.56608,
    height: 8.9164,
    transform: "rotate(40.051 21.2895 11.997)",
    fill: "#4E4E4E",
    stroke: "#A3A3A3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3164 23.064L13.4049 24.1484",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2825 8.80928C29.6075 8.6198 29.8548 8.36503 30.3208 8.75678C30.7868 9.14853 30.4924 9.73533 30.2197 10.0598C29.7639 10.602 28.789 11.1704 27.8774 12.2548C27.2697 12.9777 26.3987 14.2504 26.8647 14.6422C27.3308 15.0339 27.7511 14.7704 27.903 14.5897",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditService);
export default __webpack_public_path__ + "static/media/edit-service.fcfcd17a9cfe5ac8e8293f43d22f9529.svg";
export { ForwardRef as ReactComponent };